module.exports = __webpack_public_path__ + "static/media/Welcome_Bonus_web.d78254f7.png";